const productCategory = [
    { id : 1, label : "Cricket", value : "Cricket"},
    { id : 2, label : "Team Sport", value : "Team Sport"},
    { id : 3, label : "Athletics", value : "Athletics"},
    { id : 4, label : "Boxing", value : "Boxing"},
    { id : 5, label : "Fitness", value : "Fitness"},
    { id : 6, label : "Training", value : "Training"},
    { id : 7, label : "Indoor Games", value : "Indoor Games"},
    { id : 8, label : "Accessories", value : "Accessories"},
     { id : 9, label : "Boys Clothes", value : "Boys Clothes"},
     { id : 10, label : "Boys Shoes", value : "Boys Shoes"},
      { id : 11, label : "Jersey", value : "Jersey"},




    // { id : 9, label : "Speakers", value : "speakers"},
    // { id : 10, label : "Trimmers", value : "trimmers"},
    // { id : 11, label : "Televisions", value : "televisions"},
    // { id : 12, label : "Watches", value : "watches"},
]


export default productCategory